@if (isMenu) {
  <button mat-menu-item>
    <mat-icon>check</mat-icon>
    {{ 'markAsNotSpam' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'markAsNotSpam' | translate"
    matTooltip="{{ 'markAsNotSpam' | translate }}">
    <mat-icon>check</mat-icon>
  </button>
}
